import React, { createContext, useState, useContext } from 'react';

const EnterpriseContext = createContext(null);

export const EnterpriseProvider = ({ children }) => {
  const [companyName, setCompanyName] = useState('');
  const [companySize, setCompanySize] = useState('');
  const [activitySector, setActivitySector] = useState('');
  const [enterpriseId, setEnterpriseId] = useState(() => localStorage.getItem('enterpriseId') || '');
  const [scores, setScores] = useState({
    environmental: 0,
    social: 0,
    modernization: 0,
    leadTime: 0,
    cost: 0,
    quality: 0,
    clientConsumer: 0,
  });

  // âœ… Fonction pour mettre à  jour les scores
  const updateScores = (newScores) => {
    if (JSON.stringify(newScores) !== JSON.stringify(scores)) {
      setScores(newScores);
    }
  };

  // âœ… Fonction pour récupérer les données d'entreprise
  const fetchEnterpriseData = async (id) => {
    try {
      console.log(`fetchEnterpriseData appelé avec ID: ${id}`);

      const response = await fetch(`${process.env.REACT_APP_API_URL || ''}/api/enterprise/${id}`, {
        headers: {
          'Authorization': localStorage.getItem('token')
            ? `Bearer ${localStorage.getItem('token')}`
            : '',
        },
      });

      if (!response.ok) {
        console.error(`Erreur HTTP: ${response.status} - ${await response.text()}`);
        throw new Error(`Erreur HTTP: ${response.status}`);
      }

      const data = await response.json();
      console.log('Données entreprise reà§ues:', data);

      // Mettre à  jour l'état local
      setCompanyName(data.company_name || '');
      setCompanySize(data.company_size || '');
      setActivitySector(data.activity_sector || '');
      setEnterpriseId(id);

      return data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données:', error);
      return { success: false, error: error.message };
    }
  };

  // âœ… Fonction pour enregistrer les données d'entreprise
  const saveEnterpriseData = async (data) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL || ''}/api/save-enterprises`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': localStorage.getItem('token')
            ? `Bearer ${localStorage.getItem('token')}`
            : '',
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        throw new Error(`Erreur HTTP: ${response.status}`);
      }

      const result = await response.json();

      // âœ… Mise à  jour de l'état local
      setCompanyName(data.company_name);
      setCompanySize(data.company_size);
      setActivitySector(data.activity_sector);

      // âœ… Stocker l'ID dans le localStorage (compatibilité totale avec le PDFUploader)
      if (result.enterpriseId || result.case_id || result.id) {
        const newId = result.enterpriseId || result.case_id || result.id;

        // Sauvegarde dans le state et localStorage
        setEnterpriseId(newId);
        localStorage.setItem('enterpriseId', newId);

        // ðŸ” Synchronisation avec le PDFUploader
        localStorage.setItem('caseId', newId);

        console.log('Nouveau caseId enregistré :', newId);
      } else {
        console.warn('Aucun ID trouvé dans la réponse du backend :', result);
      }

      return result;
    } catch (error) {
      console.error('Erreur lors de la sauvegarde des données:', error);
      return { success: false, error: error.message };
    }
  };

  return (
    <EnterpriseContext.Provider
      value={{
        companyName,
        setCompanyName,
        companySize,
        setCompanySize,
        activitySector,
        setActivitySector,
        enterpriseId,
        setEnterpriseId,
        scores,
        updateScores,
        fetchEnterpriseData,
        saveEnterpriseData,
      }}
    >
      {children}
    </EnterpriseContext.Provider>
  );
};

export const useEnterprise = () => {
  const context = useContext(EnterpriseContext);
  if (!context) {
    throw new Error('useEnterprise must be used within an EnterpriseProvider');
  }
  return context;
};

